<template>
  <div class="wrapper">
    <div class="serve">
      <div class="title">最新加盟</div>
      <div class="content">
        <vue-seamless-scroll :data="serveList" :class-option="classOption">
          <div class="sc-item" v-for="(v,i) in serveList" :key="i">
            <div class="sc-title">{{ v.title }}</div>
            <div class="cycle-way">
              <div class="cycle">加盟级别:<span>{{ v.cycle }}</span></div>
              <div class="way">加盟城市:<span>{{ v.way }}</span></div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="joins">
      <div class="title">特色服务</div>
      <div class="content">
        <vue-seamless-scroll :data="joinsList" :class-option="classOption">
          <div class="content-wrapper">
            <div class="jc-item" v-for="(v,i) in joinsList" :key="i">
              <div class="image">
                <img :src="v.image">
              </div>
              <div class="name">{{ v.name }}</div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
    <div class="order">
      <div class="title">最新订单</div>
      <div class="content">
        <vue-seamless-scroll :data="orderList" :class-option="classOption">
          <div class="oc-item" v-for="(v,i) in orderList" :key="i">
            <div class="oc-title">{{ v.title }}</div>
            <div class="serve-status">
              <div class="serve-name">{{ v.serve }}</div>
              <div class="status">已签约下单</div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import VueSeamlessScroll from 'vue-seamless-scroll'
import uuid from 'uuid'

export default {
  components: {
    VueSeamlessScroll
  },
  name: "ServeJoinsOrder",
  data() {
    return {
      serveList: [],
      joinsList: [],
      orderList: []
    }
  },
  created() {
    this.getServeList()
    this.getJoinsList()
    this.getOrderList()
  },
  computed: {
    classOption() {
      return {
        step: 0.5,
        limitMoveNum: 2,
        hoverStop: false,
        direction: 1,
        openWatch: false,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1000
      }
    }
  },
  methods: {
    /**
     * 特色服务
     */
    getServeList() {
      uuid()
      this.$request.get('/Home/featureServe')
          .then(res => {
            if (res.code === 0) {
              this.serveList = res.data
            }
          })
    },
    /**
     * 最新加盟
     */
    getJoinsList() {
      this.$request.get('/Home/newestJoins')
          .then(res => {
            if (res.code === 0) {
              this.joinsList = res.data
            }
          })
    },
    /**
     * 最新订单
     */
    getOrderList() {
      this.$request.get('/Home/newestOrder')
          .then(res => {
            if (res.code === 0) {
              this.orderList = res.data
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 334px;

  .serve, .joins, .order {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;

    .title {
      width: 100%;
      height: 54px;
      background-color: #1464FF;
      padding: 0 24px;
      line-height: 54px;
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
      z-index: 1;
    }

    .content {
      flex: 1;
      height: 0;
      width: 100%;
      background-color: #FFFFFF;
      padding: 0 24px;
    }
  }

  .serve {
    width: 292px;

    .content {
      display: flex;
      flex-direction: column;

      .sc-item {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;

        .sc-title {
          color: #2D2D2D;
          font-weight: bold;
          font-size: 15px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .cycle-way {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          margin-top: 5px;

          .cycle {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #A4A4A4;
            font-size: 12px;
            width: 49%;

            span {
              flex: 1;
              width: 0;
              color: #FF3E4A;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }

          .way {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #A4A4A4;
            font-size: 12px;
            width: 49%;

            span {
              flex: 1;
              width: 0;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .joins {
    width: 528px;

    .content {
      .content-wrapper {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
      }

      .jc-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        padding-top: 2px;

        .image {
          width: 106px;
          height: 70px;
          background-color: #FFFFFF;
          box-shadow: 0 1px 7px rgba(136, 147, 169, 0.24);
          overflow: hidden;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;

          img {
            width: 112px;
            height: 87px;
          }
        }

        .name {
          margin-top: 8px;
          color: #2D2D2D;
          font-size: 14px;
          font-weight: bold;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
        }
      }
    }
  }

  .order {
    width: 340px;

    .oc-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;

      .oc-title {
        color: #2D2D2D;
        font-weight: bold;
        font-size: 15px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .serve-status {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 5px;
        font-size: 12px;

        .serve-name {
          color: #A4A4A4;
          margin-right: 20px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .status {
          color: #1464FF;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>